import { useEffect, useState } from "react";
import { cn } from '@flowstate/utils';

export function ClientMyceliumScene({ className }: { className?: string }) {
  const [Scene, setScene] = useState<React.ComponentType<{ className?: string }> | null>(null);

  useEffect(() => {
    let mounted = true;
    import("@/features/landing/components/MyceliumNetworkScene").then((mod) => {
      if (mounted) setScene(() => mod.MyceliumNetworkScene);
    });
    return () => {
      mounted = false;
    };
  }, []);

  if (!Scene) return null;
  return <Scene className={className} />;
}
